import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
// import "../theme/default.styl"
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify);

const opts = {
    icons: {
        iconfont: 'mdi', // default - only for display purposes
    },
    theme: {
        themes: {
            light: {
                primary: "#f81134",
                secondary: "#0e5d0c",
                accent: "#009688",
                error: "#f44336",
                warning: "#ffc107",
                info: "#03a9f4",
                success: "#8bc34a"
            },
            dark: {
                primary: '#04630b',
                secondary: '#b0bec5',
                anchor: '#8c9eff',
                accent: "#82B1FF",
                error: "#FF5252",
                info: "#2196F3",
                success: "#4CAF50",
                warning: "#FFC107"
            }
        }

    },
    customProperties: false
};

export default new Vuetify(opts)